(function($) {
  $(document).ready(function() {
    $("#mobile-menu span.collapse").on("click", function () {
      if (!$(".product-img-box .verticl-carousel").is(':animated')) {
        var top = $(".product-img-box .verticl-carousel > a:first-child");
        var clone = $(".product-img-box .verticl-carousel > a:first-child").clone();
        clone.appendTo(".product-img-box .verticl-carousel");
        $(".product-img-box .verticl-carousel").animate({
          "top": '-=85'
        }, 250, function () {
          top.remove();
          $(".product-img-box .verticl-carousel").animate({
            "top": "+=85"
          }, 0);
        }); 
      }
    });
    var width = $(window).width(); // New width
    console.log(width);
    if(width < 480) {
      setInterval(
        function() {
          $('.sorter_wrap .selectize-dropdown .option').each(function(){
            $(this).html($(this).text().replace(/Sort by /g, ''));
          });
          $('.selectize-input').click(function() {
            $('.sorter_wrap .selectize-dropdown .sorter_title').remove();
            $('.sorter_wrap .selectize-dropdown').prepend('<div class="sorter_title">Sort By<span class="sorter_close"></span></div>');
          });
        }, 50);
    } 
    $('.configurable-swatch-list li a').on('mouseenter', function(e){
      //console.log($(this).attr('data-color'));
      $(this).parents('.item-area').find('.product-image-area').css({background: $(this).attr('data-color')});
      $(this).parents('.item-area').find('.customize-btn').attr('href', $(this).attr('data-url'));
    });  

    setInterval(
      function() {
        var main_img_url = $('.product-image-gallery img').attr('src');
        $( ".thumb-link" ).each(function( index ) {
          var sub_img_url = $(this).attr('data-image');
          if(main_img_url == sub_img_url) {
            $( ".thumb-link" ).removeClass("zoomGalleryActive");
            $( this ).addClass("zoomGalleryActive");
          }
        });
        
      }, 50);
      $( ".thumb-link" ).click(function() {
        $( ".thumb-link" ).removeClass("zoomGalleryActive");
        $(this).addClass("zoomGalleryActive");
      });
    $('body a').each( function() {
      var customize_link = $(this).attr('href');
      //console.log(customize_link);
      if( customize_link.indexOf('customize.garmeo.com') >= 0){
        $(this).attr('target', '_blank');
      }
    });
    $('.center-slider-content .slick-active[data-slick-index="0"]').click(function(e){
    	e.preventDefault();    
    })
  });
   
  $('.products-grid .product').each(function(){
        var bg_color = $(this).find('.product-image img.main').attr('data-bg');
        $(this).find('.product-image img').css('background-color',bg_color);
    })
})(jQuery);

